import React from 'react'
// import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'
// import {remCalc} from '../../../theme/_utils'

const FavouriteIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props} aria-hidden="true">
            <path
                d="M19.9103 36.5797C19.7476 36.5797 19.595 36.539 19.4424 36.4678C9.97174 31.5951 2.46438 23.0197 1.19281 15.6038C0.572282 12.0231 1.4573 8.84926 3.73595 6.42819C5.86202 4.18005 8.30344 3.02037 10.989 3.00003C11.0195 3.00003 11.0399 3.00003 11.0704 3.00003C15.0784 3.00003 18.4862 5.51266 19.9205 6.75371C21.3955 5.50248 24.9458 2.96951 29.0453 3.00003C31.7411 3.04072 34.1825 4.19022 36.2882 6.42819C38.5465 8.81874 39.4213 11.9621 38.811 15.5021C37.5394 22.9179 29.9608 31.5443 20.3783 36.4678C20.2359 36.539 20.0731 36.5797 19.9103 36.5797ZM11.0704 5.03454C11.0704 5.03454 11.0195 5.03454 10.9992 5.03454C8.88328 5.05489 6.94031 5.99077 5.21098 7.82183C3.35957 9.78514 2.67801 12.2876 3.18663 15.258C4.31579 21.8498 11.3145 29.8455 19.9002 34.4129C28.5876 29.7946 35.6575 21.7583 36.7866 15.1563C37.2851 12.2266 36.6137 9.75462 34.7928 7.82183C33.0838 6.00094 31.1307 5.06506 29.0046 5.03454C24.5897 4.95316 20.6529 8.80857 20.6123 8.84926C20.419 9.04254 20.185 9.15444 19.89 9.14426C19.6153 9.14426 19.361 9.03237 19.1677 8.83909C19.1271 8.7984 15.3836 5.03454 11.05 5.03454H11.0704Z"
                fill="currentColor"
            />
            {/* <path
                d="M19.8462 36C23.4215 36 37.6923 24.8369 37.6923 15.0769C37.6923 8.96615 32.72 4 26.6154 4C24.3385 4 22.3815 4.68923 20.6215 6.11077L19.8462 6.73846L19.0708 6.11077C17.3108 4.68923 15.3477 4 13.0769 4C6.97231 4 2 8.96615 2 15.0769C2 24.8369 16.2708 36 19.8462 36Z"
                stroke="currentColor"
                strokeWidth={props.strokewidthnumber || remCalc(3)}
                strokeLinecap="round"
                strokeLinejoin="round"
            /> */}
        </Icon>
    )
}

// FavouriteIcon.propTypes = {
//     strokeColor: PropTypes.string,
//     strokewidthnumber: PropTypes.any,
//     fillColor: PropTypes.string,
// }

export default FavouriteIcon
